import { Component, OnInit, AfterContentChecked, Input } from '@angular/core';

@Component({
  selector: 'app-turns-controls-card',
  templateUrl: './turns-controls-card.component.html',
  styleUrls: ['./turns-controls-card.component.scss']
})
export class TurnsControlsCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
